import { actionCreator, reducedStream, reducer } from '@ardoq/rxbeach';
import { updateState } from '@ardoq/common-helpers';
import { FullscreenWidgetData } from '@ardoq/dashboard';

export type FullscreenWidgetState =
  | {
      isOpen: true;
      widgetData: FullscreenWidgetData;
    }
  | {
      isOpen: false;
      widgetData: null;
    };

export type OpenFullScreenWidgetPayload = {
  widgetData: FullscreenWidgetData;
};

const defaultState: FullscreenWidgetState = {
  isOpen: false,
  widgetData: null,
};

export const openedFullscreenWidget =
  actionCreator<OpenFullScreenWidgetPayload>(
    '[fullscreenWidget] OPENED_FULLSCREEN_WIDGET'
  );

export const closedFullscreenWidget = actionCreator(
  '[fullscreenWidget] CLOSED_FULLSCREEN_WIDGET'
);

const openModalAndSetWidgetData = (
  state: FullscreenWidgetState,
  { widgetData }: OpenFullScreenWidgetPayload
): FullscreenWidgetState => ({
  ...state,
  isOpen: true,
  widgetData,
});

export const fullscreenWidget$ = reducedStream<FullscreenWidgetState>(
  'fullscreenWidget$',
  defaultState,
  [
    reducer(openedFullscreenWidget, openModalAndSetWidgetData),
    reducer(
      closedFullscreenWidget,
      updateState({ isOpen: false, widgetData: null })
    ),
  ]
);
